@let isInsideSummary = $isInsideSummary();
@let qualityControlStatus = $request().qualityControlStatus;
@let qualityControlStatusText = $qualityControlStatusText();
@let isLoading = !!(isLoading$ | async);
@let requestQCRatings = $ratings();

<style>
  [tuiButton][data-appearance='flat'] {
    --tui-padding: 1rem;
    margin-left: -1rem;
    width: calc(100% + 2rem);
  }
  hr {
    border-bottom: 1px solid var(--x-color-gray);
    margin-left: -1rem;
    width: calc(100% + 2rem);
  }
</style>

<div
  class="x-card x-card_size_m x-white mx-auto"
  [ngClass]="{
    'md:w-1/3 mt-4.5': !isInsideSummary,
    'p-[20px] h-full box-border': isInsideSummary,
  }"
>
  <header class="flex items-center justify-between mb-4">
    <div>
      <p class="x-font-body-1-bold">
        {{ 'request_form.qc.qc_title' | translate }}
        @if (
          qualityControlStatus ===
          RequestQualityControlStatusEnum.HasCriticalErrors
        ) {
          <tui-icon
            [style.border-width.rem]="0.25"
            icon="@tui.circle-alert"
            class="ms-1.5 rounded-full x-bg-red text-white"
          />
        }
      </p>
    </div>

    @if (permissionService.canEditQualityControlStatuses$ | async) {
      <x-icon-button
        [size]="32"
        iconName="@tui.pencil"
        [iconSize]="16"
        class="self-end absolute top-4 right-4"
        [clickFunction]="
          showQualityStatusesModal.bind(this, allRatingsModalContent)
        "
      />
    }
  </header>
  <section class="x-card__paragraph mt-5">
    <p class="x-font-body-4 x-text-dark-75">Статус проверки</p>
    <p class="x-font-body-4-bold x-text-dark-main">
      {{ qualityControlStatusText | translate }}
    </p>
  </section>
  <section class="x-card__paragraph mt-5">
    @for (
      rating of requestQCRatings;
      track rating.id;
      let idx = $index;
      let count = $count
    ) {
      @if (idx < 4) {
        <p>
          <span
            tuiBadge
            class="checked-summary-rating-badge mb-2 cursor-pointer"
            [ngClass]="{ 'max-w-[330px]!': count > 4 && idx === 3 }"
            [tuiHint]="getRatingHintText(rating)"
            tuiHintAppearance="dark"
            (click)="openRatingDetailsModal(ratingDetailsModalContent, rating)"
            [ngStyle]="{
              'border-color': rating.fixed
                ? '#8BC34A'
                : rating.color === '#ffffff'
                  ? '#dadada'
                  : rating.color,
            }"
            ><div
              class="w-[10px] h-[10px] rounded-[50%] me-2"
              [ngStyle]="{
                'background-color': rating.fixed
                  ? '#8BC34A'
                  : rating.color === '#ffffff'
                    ? '#dadada'
                    : rating.color,
              }"
            ></div>
            {{ rating | entityTranslate: 'request_ratings' }}</span
          >
          @if (count > 4 && idx === 3) {
            <span tuiBadge class="ms-1 mb-2 font-medium! p-0!" size="l">{{
              '+' + (count - 4)
            }}</span>
          }
        </p>
      }
    }
  </section>
</div>

<ng-template #ratingButtonTemplate let-rating="rating">
  <button
    tuiButton
    appearance="flat"
    type="button"
    class="w-full first:pt-0 h-auto! rounded-none!"
    [disabled]="isLoading"
    (click)="handleButtonClick(rating)"
  >
    <div class="flex items-center justify-between py-4 w-full">
      <div class="text-left">
        <span
          class="inline-block w-4 h-4 rounded-full align-middle mr-2"
          [style.background-color]="rating.color"
          [ngClass]="{
            'border border-(--x-color-green)': rating.color === '#ffffff',
          }"
        ></span>
        <span
          class="typo-ui-m x-text-01 text-left font-medium pr-2 shrink min-w-0 whitespace-normal"
          >{{ rating | entityTranslate: 'request_ratings' }}</span
        >
      </div>
      <input
        tuiCheckbox
        type="checkbox"
        size="m"
        [(ngModel)]="ratingsStatus[rating.id]"
        (ngModelChange)="toggleRating$.next(rating)"
      />
    </div>
  </button>
  <hr class="last:hidden" />
</ng-template>

<ng-template #allRatingsModalContent>
  <header class="mb-4 x-font-body-1-bold">
    {{ 'request_form.qc.qc_modal_title' | translate }}
  </header>
  @for (rating of $allQCRatings(); track rating.id) {
    <ng-container
      *ngTemplateOutlet="ratingButtonTemplate; context: { rating: rating }"
    ></ng-container>
  }
</ng-template>

<ng-template #ratingDetailsModalContent let-rating="data" let-data>
  <header class="mb-4 x-font-body-1-bold">
    {{ rating | entityTranslate: 'request_ratings' }}
  </header>
  <p class="x-font-body-4 x-text-dark-75">
    {{ 'request_form.qc.created' | translate }}
  </p>
  <p class="x-font-body-4-bold x-text-dark-main mb-2">
    {{ rating.createdBy }}, {{ rating.createdAt }}
  </p>
  <p class="x-font-body-4 x-text-dark-75">
    {{ 'request_form.qc.qc_comment' | translate }}
  </p>
  <p class="x-font-body-4-bold x-text-dark-main mb-2 flex items-center">
    @if (qualityControlCommentEditing) {
      <tui-input-inline class="max-w-[500px]">
        {{ 'request_form.qc.enter_comment_placeholder' | translate }}
        <input
          tuiAutoFocus
          [(ngModel)]="qualityControlComment"
          (focusout)="onFocusedQCCommentChange(false, rating)"
          (keydown.enter.prevent)="saveQcComment(rating)"
          (keydown.esc.prevent)="saveQcComment(rating)"
        />
      </tui-input-inline>
    } @else {
      <span>{{
        qualityControlComment || 'request_form.qc.no_comment' | translate
      }}</span>
      <button
        appearance="icon"
        iconStart="@tui.pencil"
        size="xs"
        tuiIconButton
        type="button"
        class="ml-1"
        (click)="toggleEditQCComment()"
      ></button>
    }
  </p>
  @if (rating.fixed) {
    <p class="x-font-body-2 x-text-dark-main mb-2 x-text-green">
      {{ 'request_form.qc.problem_solved' | translate }}
    </p>
    <p class="x-font-body-4 x-text-dark-75">
      {{ 'request_form.qc.installer_comment' | translate }}
    </p>
    <p class="x-font-body-4-bold x-text-dark-main">
      {{ rating.installerComment || 'request_form.qc.no_comment' | translate }}
    </p>
  }
</ng-template>
